import { Application } from "./types";
import * as Actions from './actions.type'
// import * as Mutations from './mutations.type'
import * as Services from './services'

interface State {
  list: Application[], // список элементов для начальной страницы
  item: Application | null,  // открытый элемент при редактировании в диалоге
  // customData: CustomData | null, // пример кастомного поля
}

const store: State = {
  list: [],
  item: null,
  // customData: null,
}

const getters = {
  // секции приложения в удобном виде для получения по коду ее данных
  appSections: (state: State) => {
    if (state.list.length == 0 || !state.list[0].sections) return null
    return state.list[0].sections
      .filter(s => s.active)
      .reduce((acc: any, section: any) => {
        acc[section.code] = section
        return acc
      }
    , {})
  },
}

const actions = {
  [Actions.APP_CREATE_DEFAULT_SECTIONS]: Services.setDefaultSections,
}

const mutations = {
  // [Mutations.SET_CUSTOM_DATA](state: State, data: CustomData) {
  //   state.customData = data
  // }
}

export default {
  namespaced: true,
  state: store,
  getters,
  actions,
  mutations,
}; 